import React from "react";

const initial = { name: "", status: "" };

export default function CategoriesFilter({ value, onChange }) {
  const [form, setForm] = React.useState(value || initial);
  React.useEffect(() => setForm(value || initial), [value]);
  const setField = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const submit = (e) => { e?.preventDefault?.(); onChange?.(form); };
  const reset = () => { setForm(initial); onChange?.(initial); };

  return (
    <form onSubmit={submit}>
      <div className="oc-f-grid">
        <div className="oc-field">
          <label>Name</label>
          <input className="oc-input" placeholder="Category name"
            value={form.name} onChange={(e)=>setField("name", e.target.value)} />
        </div>
        <div className="oc-field">
          <label>Status</label>
          <select className="oc-select" value={form.status}
            onChange={(e)=>setField("status", e.target.value)}>
            <option value="">All</option>
            <option value="1">Enabled</option>
            <option value="0">Disabled</option>
          </select>
        </div>
        <div className="oc-actions">
          <button className="oc-btn" type="submit">Filter</button>
          <button className="oc-btn ghost" type="button" onClick={reset}>Reset</button>
        </div>
      </div>
    </form>
  );
}

